import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import './ContactForm.css';
import Meta from './Meta'; 
import noutImage from './assets/celovek-nabrav-na-noutbuke-krupnym-planom.jpg';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function PriznakiChtoNuzhenSistemnyjAdministrator() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

   return (
       <React.Fragment>
    <Meta
    title="5 признаков, что вашему бизнесу срочно нужен сисадмин | IT-аутсорсинг"
    description="«Всё тормозит», данные под угрозой, а расходы растут? Узнайте, как системный администратор на аутсорсинге решит ваши IT-проблемы. Защита и стабильная работа 24/7."
    />

    <div
    style={{
            fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
            maxWidth: '900px',
            margin: '0 auto',
            padding: '40px 20px',
            lineHeight: 1.6,
            backgroundColor: '#f9f9f9',
            color: '#333',
            }}
    >
        <h1
    style={{
    textAlign: 'center',
    marginBottom: '30px',
    color: '#2c3e50',
    }}
    >
    5 тревожных признаков, что вашему бизнесу срочно нужен системный администратор (и как решить это быстро)
    </h1>
        <p style={{ float: 'right', maxWidth: '40%', marginLeft: '20px', marginBottom: '10px' }}>
                 <img src={noutImage} alt="Internet Illustration" style={{ width: '100%', height: 'auto' }} />
            </p>
    <p>
    Вы владелец или руководитель компании, где работает от 10 до 100 человек? Скорее всего, у вас нет штатного системного администратора. Проблемы с компьютерами, сетью или программами решаются «по знакомству», силами наиболее продвинутого сотрудника или вообще остаются без внимания.</p>
    <p>
    <strong>Это стратегическая ошибка.</strong> Сегодня IT-инфраструктура — это такая же коммунальная услуга, как электричество или вода. Её отсутствие или нестабильная работа парализует бизнес.
    </p>
    <p>Как понять, что вы уже на грани серьезных потерь? Вот 5 явных признаков, что вашему бизнесу срочно требуется профессиональный системный администратор. А главное — мы расскажем о самом эффективном и выгодном решении этой проблемы для среднего и малого бизнеса.</p>

    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Признак 1: «Технические проблемы съедают рабочее время сотрудников и ваши нервы»</h2>

    <ul>
    <li><strong>Опять не печатает принтер!</strong></li>
    <li><strong>Слетела 1С, не могу отгрузить товар.</strong></li>
    <li><strong>Пропал интернет, все встали.</strong></li>
    <li><strong>Не открывается важная папка на общем диске.</strong></li>
    </ul>
    <p>Знакомо? Если такие ситуации — регулярная головная боль, а их решение занимает часы, значит, ваши сотрудники (часто ключевые) тратят свое дорогое время не на свои прямые обязанности, а на устранение сбоев. Простой одного сотрудника из-за IT-проблемы может стоить компании десятки тысяч рублей в месяц.</p>
    <p><strong>Решение:</strong> Системный администратор берет на себя всю техническую поддержку. Он либо оперативно решает проблемы удаленно, либо выезжает на место. Внедряет систему заявок (тикет-систему), где все сбои фиксируются, распределяются по приоритету и решаются в рабочем порядке, не отвлекая весь офис.</p>
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Признак 2: Вы не уверены в безопасности ваших данных</h2>

    <ul>
    <li><strong>Пароли к почте и бухгалтерским программам хранятся в файле passwords.txt на рабочем столе.</strong></li>
    <li><strong>Нет ясности, кто и к каким данным имеет доступ.</strong></li>
    <li><strong>Нет настроенного антивируса на сервере или он давно не обновлялся.</strong></li>
    <li><strong>Резервные копии делаются «вручную, когда вспомню» или не делаются вовсе.</strong></li>
    </ul>
    
    <p>Это прямой путь к катастрофе. Утечка клиентской базы, потеря финансовых данных, шифровальщик-вирус, который парализует все компьютеры — риски, которые могут привести бизнес к банкротству. По статистике, более 60% малых компаний после серьезной потери данных закрываются в течение полугода.</p>
    <p><strong>Решение:</strong> Первое, что делает профессиональный сисадмин — <strong>аудит безопасности</strong>. Он настраивает политики доступа, устанавливает и настраивает корпоративные защитные решения, но главное — внедряет автоматическое резервное копирование с проверкой восстановления. Вы будете спать спокойно, зная, что даже в случае атаки данные можно быстро восстановить.</p>
    
   <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Признак 3: IT-расходы непредсказуемы и постоянно растут</h2>
    <p>Вы не можете спрогнозировать, сколько потратите на IT в следующем месяце. То сломался жесткий диск, то нужно срочно купить новую лицензию, то «внезапно» закончилась подписка на сервис. Деньги уходят реактивно, на тушение пожаров, а не на развитие инфраструктуры.</p>
    <p><strong>Решение: Аутсорсинг сисадмина</strong> чаще всего работает по модели абонентского обслуживания. Вы платите фиксированную сумму в месяц и получаете полный пакет услуг: мониторинг, поддержка, консультации, профилактика. Все непредвиденные расходы (кроме поломки «железа») ложатся на плечи подрядчика. Это дает вам полную финансовую предсказуемость.</p>
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Признак 4: Нет единой и стабильной IT-среды</h2>
    <p>В компании «зоопарк» из техники и программ: кто-то работает на Windows 10, кто-то на устаревшей «семерке», бухгалтерия использует одну версию 1С, а склад — другую. Нового сотрудника неделями не могут подключить ко всем необходимым ресурсам. Это приводит к несовместимости, уязвимостям и колоссальным затратам времени на администрирование.</p>
    <p><strong>Решение:</strong> Сисадмин <strong>стандартизирует и централизует IT-инфраструктуру.</strong> Он создает учетные записи пользователей, настраивает единые политики, разворачивает необходимое ПО на всех компьютерах, обеспечивает бесперебойную работу сетевых ресурсов и почтового сервера. Новый сотрудник получает готовое рабочее место за час.</p>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Признак 5: Бизнес зависит от одного «технического гуру»</h2>
    <p>Это самый опасный признак. В офисе есть человек (не IT-специалист по должности), который «всем помогает». Он знает все пароли, настройки и костыли в системе. Что произойдет, если он заболеет, уйдет в отпуск или решит сменить работу? Бизнес встанет. Кроме того, такой сотрудник, как правило, не обладает экспертизой для построения надежных и безопасных систем.</p>
    <p><strong>Решение: Передать ответственность профессионалам.</strong> Когда IT-инфраструктурой занимается команда или специалист на аутсорсинге, вы получаете не одного человека, а отлаженный процесс. Все знания, доступы и схемы работы документированы. В случае болезни основного инженера его заменит коллега. Ваш бизнес перестает зависеть от личности.</p>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Что делать? Не нанимать в штат, а взять в аренду!</h2>
    
    <p>Для большинства компаний малого и среднего бизнеса содержание штатного системного администратора — неоправданно дорого. Зарплата специалиста, налоги, отпуска, больничные, оборудование для работы.</p>
    <p>Современное и выгодное решение — IT-аутсорсинг услуг системного администратора.</p>
    <p>Это как аренда автомобиля с водителем вместо покупки своей машины и найма шофера. Вы платите только за результат — стабильную и безопасную работу всех IT-систем.</p>
    
    <p>Что вы получаете с аутсорсинговым системным администратором от ИТ Особа?</p>
    <ul>
    <li><strong>Команда специалистов вместо одного человека:</strong> За вашей инфраструктурой следят инженеры разных профилей (сети, серверы, безопасность).</li>
    <li><strong>Круглосуточный мониторинг:</strong> Мы видим проблемы еще до того, как о них узнают ваши сотрудники.</li>
    <li><strong>Фиксированная ежемесячная стоимость.</strong> Никаких сюрпризов.</li>
    <li><strong>Глубокая экспертиза и опыт работы с разными бизнесами.</strong></li>
    <li><strong>Фокус на профилактике,</strong> а не на тушении пожаров. Мы делаем так, чтобы проблемы не возникали.</li>
    <p>Не ждите, пока один из этих пяти признаков приведет к потере денег или данных.</p>
    <p><strong>Первым шагом должен стать профессиональный IT-аудит.</strong> Наши специалисты бесплатно проанализируют вашу инфраструктуру, выявят узкие места и риски и предоставят четкий план по их устранению.</p>
    <p>Оставьте заявку или позвоните нам для проведения бесплатного аудита!</p>
    </ul> 
    
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button>
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
      </div>

    </React.Fragment>
  );
}